import { render, staticRenderFns } from "./InviteDemandDetails.vue?vue&type=template&id=71f74b8f&scoped=true&"
import script from "./InviteDemandDetails.vue?vue&type=script&lang=js&"
export * from "./InviteDemandDetails.vue?vue&type=script&lang=js&"
import style0 from "./InviteDemandDetails.vue?vue&type=style&index=0&id=71f74b8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f74b8f",
  null
  
)

export default component.exports